import defaultPage from "@/mixins/pages/default.mixin";
import langSelect from "@/mixins/components/langSelect.mixin";
import yearSelect from "@/mixins/components/yearSelect.mixin";
import ItemList from "@/components/ItemList/ItemList";
import ListLayout from "@/layouts/List";

export default strategy => {
  return {
    data() {
      return {
        pagination: {}
      };
    },
    mixins: [defaultPage(strategy), langSelect, yearSelect],
    components: {
      ListLayout,
      ItemList
    }
  };
};
